import { render } from "./SideBarLog.vue?vue&type=template&id=a27d8842&scoped=true&ts=true"
import script from "./SideBarLog.vue?vue&type=script&lang=ts"
export * from "./SideBarLog.vue?vue&type=script&lang=ts"

import "./SideBarLog.vue?vue&type=style&index=0&id=a27d8842&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27d8842"]])

export default __exports__